import { AppState } from './types';
import { localStorage } from '@/utils/storage';
import { defineStore } from 'pinia';
import { getLanguage } from '@/lang/index';
import i18n from '@/lang/index';

const useAppStore = defineStore('app', {
  state: (): AppState => ({
    device: 'desktop',
    language: getLanguage(),
    size: localStorage.get('size') || 'default'
  }),
  actions: {
    setSize(size: string) {
      this.size = size;
      localStorage.set('size', size);
    },
    setLanguage(language: string) {
      this.language = language;
      localStorage.set('language', language);
      i18n.global.locale.value = language;
    }
  }
});

export default useAppStore;
